import {
  identifyUserInAnalytics,
  initAnalytics,
  resetAnalyticsSession,
  stopAnalytics,
} from './analytics'
import { identifyUserInLogger, initLogger, stopLogger } from '@/services/logger'
import { logger } from '@/services/logger/loggers'
import {
  identifyUserInMonitor,
  initMonitor,
  stopMonitor,
} from '@/services/monitor'
import { getStateProfile } from '@/store'
import { initGTM } from '@/plugins/gtManager'

let state: 'stopped' | 'started' = 'stopped'

export function startTracking() {
  if (state === 'started') {
    return
  }
  initLogger()
  initMonitor()
  initAnalytics()
  initGTM()
  state = 'started'

  log('tracking is started')
}

export function identifyUserInTracking(onLogin = false) {
  if (state === 'stopped') {
    return
  }
  const profile = getStateProfile()

  identifyUserInAnalytics({ onLogin })
  identifyUserInLogger(profile.id, profile.email)
  identifyUserInMonitor(profile.id, profile.email)

  log('user is identified')
}

export function anonymizeTracking() {
  if (state === 'stopped') {
    return
  }
  resetAnalyticsSession()
  log('user is anonymized')
}

export function stopTracking() {
  stopAnalytics()
  stopMonitor()
  stopLogger()
  state = 'stopped'

  log('tracking is stopped')
}

function log(message: string) {
  const prefix = '[otters-shell - tracking]'
  logger.info(`${prefix} ${message}`, {})
  console.log(`${prefix} ${message}`)
}
